import { Component, EventEmitter, Input, Output } from '@angular/core';
import { COLUMNS_HEADER_FINE_TUNNING } from '../../core/constants/tables.constants';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { faBars, faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { FieldType } from '../../core/enums/general.enum';
@Component({
  selector: 'app-drag-and-drop-table',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule],
  templateUrl: './drag-and-drop-table.component.html',
  styleUrl: './drag-and-drop-table.component.scss'
})
export class DragAndDropTableComponent {

  @Input() data: any;
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();

  dragStartIndex: number = -1;
  iconDelete = faTrashCan;
  FieldType = FieldType;
  faBars = faBars;


  TABLE_HEADERS = COLUMNS_HEADER_FINE_TUNNING;

    constructor() { }

    onDragStart(event: DragEvent, item: any) {
      this.dragStartIndex = this.data.indexOf(item);
      event.dataTransfer?.setData('text/plain', JSON.stringify(item));
      event.dataTransfer!.effectAllowed = 'move';
    }
    
    onDragOver(event: DragEvent) {
      event.preventDefault();
      event.dataTransfer!.dropEffect = 'move';
    }
    
    onDrop(event: DragEvent, item: any) {
      event.preventDefault();
      const dragEndIndex = this.data.indexOf(item);
      if (this.dragStartIndex !== -1 && dragEndIndex !== -1) {
        this.swapItems(this.dragStartIndex, dragEndIndex);
      }
    }
    
    swapItems(fromIndex: number, toIndex: number) {
      const [movedItem] = this.data.splice(fromIndex, 1);
    
      this.data.splice(toIndex, 0, movedItem);
    
      this.dataChange.emit(this.data);
    }
    
}
